import UserAvatar from "assets/images/v2/user-avatar.svg";
import "./ProfileMenu.scss";

interface ProfileMenuProps {
  readonly onClick?: () => void;
}

const ProfileMenu: React.FC<ProfileMenuProps> = ({ onClick }) => {
  return (
    <button type="button" className="profile-menu" onClick={onClick}>
      <img src={UserAvatar} alt="User icon" />
    </button>
  );
};

export default ProfileMenu;
